import React from 'react';

import { Fieldset, Legend } from './styles';

type PropTypes = {
  className?: string;
  labelClassName?: string;
  label?: React.ReactNode;
  children: React.ReactNode;
};

const FieldGroup = ({ className, labelClassName, children, label }: PropTypes): JSX.Element => (
  <Fieldset className={className}>
    {label && <Legend className={labelClassName}>{label}</Legend>}
    {children}
  </Fieldset>
);

export default FieldGroup;
